import { useState } from "react";

function useLocalStorageBoolean(key: string, initialValue: string) {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const item = localStorage.getItem(key);
			return item ? JSON.parse(item) : JSON.parse(initialValue);
		} catch (error) {
			console.error("Error reading localStorage", error);
			return initialValue;
		}
	});

	const setValue = (value: string | boolean) => {
		try {
			const valueToStore = value === true || value === false ? value : initialValue;
			setStoredValue(valueToStore);
			localStorage.setItem(key, "false");
		} catch (error) {
			console.error("Error writing to localStorage", error);
		}
	};

	return [storedValue, setValue];
}

export default useLocalStorageBoolean;
